export default "__VITE_ASSET__QHlBNBmV__"